import React, { useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import AuthPage from './pages/AuthPage';
import ProfileSetup from './pages/ProfileSetup';
import Dashboard from './pages/Dashboard';
import Beschikbaarheid from './pages/Beschikbaarheid';
import MijnPlanning from './pages/MijnPlanning';
import ProfielBewerken from './pages/ProfielBewerken';
import AdminVrijwilligers from './pages/AdminVrijwilligers';
import AdminWeken from './pages/AdminWeken';
import AdminPlanning from './pages/AdminPlanning';
import Sidebar from './components/Sidebar';
import './index.css';

function ProtectedApp() {
  const { currentUser, userProfile } = useAuth();
  const [page, setPage] = useState('dashboard');

  if (!currentUser) return <Navigate to="/auth" />;
  if (userProfile && !userProfile.profileComplete) return <Navigate to="/profiel-aanmaken" />;

  const renderPage = () => {
    switch (page) {
      case 'dashboard': return <Dashboard setPage={setPage} />;
      case 'beschikbaarheid': return <Beschikbaarheid />;
      case 'planning': return <MijnPlanning />;
      case 'profiel': return <ProfielBewerken />;
      case 'admin-vrijwilligers': return userProfile?.role === 'admin' ? <AdminVrijwilligers /> : <Dashboard setPage={setPage} />;
      case 'admin-weken': return userProfile?.role === 'admin' ? <AdminWeken /> : <Dashboard setPage={setPage} />;
      case 'admin-planning': return userProfile?.role === 'admin' ? <AdminPlanning /> : <Dashboard setPage={setPage} />;
      default: return <Dashboard setPage={setPage} />;
    }
  };

  return (
    <div className="page-layout">
      <Sidebar page={page} setPage={setPage} />
      <main className="main-content">
        {renderPage()}
      </main>
    </div>
  );
}

function AppRoutes() {
  const { currentUser, userProfile } = useAuth();

  return (
    <Routes>
      <Route path="/auth" element={!currentUser ? <AuthPage /> : <Navigate to="/app" />} />
      <Route path="/profiel-aanmaken" element={
        !currentUser ? <Navigate to="/auth" /> :
        userProfile?.profileComplete ? <Navigate to="/app" /> :
        <ProfileSetup />
      } />
      <Route path="/app" element={<ProtectedApp />} />
      <Route path="*" element={<Navigate to={currentUser ? '/app' : '/auth'} />} />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </AuthProvider>
  );
}
